// Center block indicator

export default function CenterIndicator({num, service = false}) {
    return (
        <div data-aos="fade-in" className={service ? "w-14 m-auto select-none z-10 grid grid-cols-1 divide-y divide-servo-600 my-4" : "select-none z-10 grid grid-cols-1 divide-y divide-servo-600 my-4"}>
            <div className="pb-2 w-32 text-servo-600">{num}</div>
            <div></div>
        </div>
    )
}